"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.interruption.hint': 'You can interrupt the agent by speaking',
    'conversation.interruption.active': 'Interrupting agent...',
};
